import { useClipsStore } from "../ClipsStore/clipsStore";
import { yyyymmddGenerator } from "../../Analytics/AnalyticsUtils/yyyymmddGenerator";

export const generateDownloadString = () => {
  const { userFiltersSMTP } = useClipsStore.getState();

  // Get customer_id from site_ids (first site ID)
  const customer_id =
    userFiltersSMTP.site_ids && userFiltersSMTP.site_ids.length > 0
      ? parseInt(userFiltersSMTP.site_ids[0])
      : null;

  // Get camera_id from camera_ids (first camera ID)
  const camera_id =
    userFiltersSMTP.camera_ids && userFiltersSMTP.camera_ids.length > 0
      ? parseInt(userFiltersSMTP.camera_ids[0])
      : null;

  // Format dates to YYYY-MM-DD
  const start_date = userFiltersSMTP.start_date
    ? yyyymmddGenerator(userFiltersSMTP.start_date)
    : "";

  const end_date = userFiltersSMTP.end_date
    ? yyyymmddGenerator(userFiltersSMTP.end_date)
    : "";

  // Format times to HH:MM
  const formatTimeForAPI = (time: Date | null) => {
    if (!time) return "";
    return time.toTimeString().split(" ")[0].substring(0, 5); // Get HH:MM format
  };

  const start_time = formatTimeForAPI(userFiltersSMTP.start_time);
  const end_time = formatTimeForAPI(userFiltersSMTP.end_time);

  // Build query parameters
  const params = [];

  // Prefer the narrowest scope the user has selected: a specific camera, then
  // a specific site, otherwise the whole group. Previously an empty
  // customer_id was always sent when no site was picked, which could never
  // resolve to a group-wide report.
  if (userFiltersSMTP.camera_ids.length !== 0) {
    params.push(`camera_id=${camera_id || ""}`);
  } else if (userFiltersSMTP.site_ids.length !== 0) {
    params.push(`customer_id=${customer_id}`);
  } else if (userFiltersSMTP.group_id) {
    params.push(`group_id=${userFiltersSMTP.group_id}`);
  }

  if (start_date) params.push(`start_date=${start_date}`);
  if (end_date) params.push(`end_date=${end_date}`);
  if (start_time) params.push(`start_time=${start_time}`);
  if (end_time) params.push(`end_time=${end_time}`);

  return `?${params.join("&")}`;
};
